import { useState } from "react";
import { Check, X, Loader2, MessageCircle, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { AutonomyPill } from "./Badges";

/** A WhatsApp follow-up PREPARED by Nadia — needs explicit approval. */
export function FollowUpCard({ fu, mode, onApprove, onReject }) {
  const [text, setText] = useState(fu.text);
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(null);

  const run = async (kind) => {
    setBusy(kind);
    try {
      if (kind === "approve") await onApprove(fu.id, text);
      else await onReject(fu.id);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="rounded-2xl border border-amber-500/20 bg-amber-500/[0.03] p-4" data-testid={`follow-up-${fu.id}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <span className="w-8 h-8 rounded-lg bg-emerald-500/10 border border-emerald-500/25 text-emerald-300 flex items-center justify-center shrink-0">
            <MessageCircle size={14} />
          </span>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-slate-100 truncate">{fu.lead_name}</div>
            <div className="text-[11px] text-slate-500 font-mono">+{fu.to} · {fu.reason}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <AutonomyPill level="PREPARA" />
          <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">{mode === "live" ? "WhatsApp configurato" : "WhatsApp non configurato"}</span>
        </div>
      </div>

      {editing ? (
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="mt-3 bg-[#0B1120] border-white/10 text-slate-100 text-sm min-h-[90px]"
          data-testid={`follow-up-text-${fu.id}`}
        />
      ) : (
        <button
          onClick={() => setEditing(true)}
          className="group mt-3 w-full text-left rounded-xl bg-[#0B1120] border border-white/5 px-4 py-3 text-sm text-slate-200 leading-relaxed hover:border-cyan-400/30 transition-colors"
          data-testid={`follow-up-preview-${fu.id}`}
        >
          {text}
          <span className="ml-2 inline-flex items-center text-[10px] text-slate-500 group-hover:text-cyan-300"><Pencil size={10} className="mr-1" />modifica</span>
        </button>
      )}

      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <Button
          size="sm"
          onClick={() => run("approve")}
          disabled={!!busy || !text.trim()}
          className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold"
          data-testid={`follow-up-approve-${fu.id}`}
        >
          {busy === "approve" ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <Check size={13} className="mr-1.5" />}
          Approva e invia
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => run("reject")}
          disabled={!!busy}
          className="border-white/10 text-slate-300 bg-transparent hover:text-rose-300 hover:border-rose-400/40"
          data-testid={`follow-up-reject-${fu.id}`}
        >
          {busy === "reject" ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <X size={13} className="mr-1.5" />}
          Non inviare
        </Button>
        <span className="text-[11px] text-slate-500">Nadia non invia nulla senza il tuo ok.</span>
      </div>
    </div>
  );
}
